var render = function render(){var _vm=this,_c=_vm._self._c;return _c('star-rating',{attrs:{"id":_vm.ratingId,"name":_vm.name,"rating":_vm.value,"read-only":_vm.disabled,"show-rating":false,"active-color":"#084298","inactive-color":"#DEE2E6","rounded-corners":true,"clearable":"","star-size":36,"padding":6,"max-rating":_vm.maxRating},on:{"rating-selected":(newRating) => _vm.$emit('input', newRating)}})
}
var staticRenderFns = []

export { render, staticRenderFns }